import React from "react";
import { Route, Switch, Redirect } from "react-router";

// components and containers
// import App from '../App';
import Login from "../containers/Login/";
import Register from "../containers/Register/";
import Organizations from "../containers/Organization/";
import Editor from "../containers/Editor";
import MapEditor from "../containers/MapEditor";
import PlayerContainer from "../containers/PlayerContainer";
import {
  ProjectIndexContainer,
  ProjectNewContainer,
} from "../containers/Project";
import NotFound from "../containers/NotFound";

import ProtectedRoute from "./ProtectedRoute";

const Routes = () => (
  <Switch>
    <Route path="/login" component={Login} />
    <Route path="/register" component={Register} />
    <ProtectedRoute path="/projects/add" component={ProjectNewContainer} />
    <ProtectedRoute
      path="/projects/:projectId?"
      component={ProjectIndexContainer}
    />
    <ProtectedRoute path="/organizations" component={Organizations} />
    <ProtectedRoute
      exact
      path="/editor/:projectId/:sceneId?/:layerId?/:widgetId?"
      component={Editor}
    />
    <ProtectedRoute
      exact
      path="/map-editor/:projectId/:sceneId?"
      component={MapEditor}
    />
    <Route path="/not-found" component={NotFound} />
    <Route
      exact
      path="/embed/:menuBottom/:mapBottom/:projectId/:sceneId?/:layerId?/:widgetId?"
      component={PlayerContainer}
    />
    <Route
      exact
      path="/:projectId/:sceneId?/:layerId?/:widgetId?"
      component={PlayerContainer}
    />
    <Redirect from="/" to="/projects" />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/router/routes.js